import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import {
  Table as TableIcon, Eye, Loader2, Search, Wrench,
} from 'lucide-react';

export function AccessTablesList({
  filteredTables, searchTerm, setSearchTerm, rowLimit, setRowLimit,
  tablesError, repairing, onRepair, onViewTable,
}) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4">
          <CardTitle className="font-heading">Tablas Disponibles</CardTitle>
          <div className="flex items-center gap-2">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input
                placeholder="Buscar tabla..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-9 w-64"
                data-testid="search-tables-input"
              />
            </div>
            <select
              value={rowLimit}
              onChange={(e) => setRowLimit(Number(e.target.value))}
              className="h-9 px-3 border rounded-md text-sm"
              data-testid="row-limit-select"
            >
              <option value={50}>50 filas</option>
              <option value={100}>100 filas</option>
              <option value={500}>500 filas</option>
              <option value={1000}>1000 filas</option>
            </select>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {tablesError ? (
          <div className="text-center py-12">
            <Wrench className="w-12 h-12 mx-auto mb-4 text-orange-500" />
            <p className="text-muted-foreground mb-2">
              No se pudieron cargar las tablas
            </p>
            <p className="text-sm text-muted-foreground mb-4">
              Es posible que falten herramientas del sistema. Haz clic en "Reparar" para solucionar.
            </p>
            <Button
              onClick={onRepair}
              disabled={repairing}
              className="bg-orange-600 hover:bg-orange-700"
              data-testid="repair-tools-btn"
            >
              {repairing ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Reparando...
                </>
              ) : (
                <>
                  <Wrench className="w-4 h-4 mr-2" />
                  Reparar Herramientas
                </>
              )}
            </Button>
          </div>
        ) : filteredTables.length === 0 ? (
          <div className="text-center py-12">
            <TableIcon className="w-12 h-12 mx-auto mb-4 text-muted-foreground opacity-50" />
            <p className="text-muted-foreground">
              {searchTerm ? 'No se encontraron tablas' : 'No hay tablas disponibles'}
            </p>
          </div>
        ) : (
          <div className="divide-y">
            {filteredTables.map((table) => (
              <div
                key={table.name}
                className="flex items-center justify-between p-4 hover:bg-muted/50 transition-colors"
                data-testid={`table-row-${table.name}`}
              >
                <div className="flex items-center gap-3">
                  <TableIcon className="w-5 h-5 text-muted-foreground" />
                  <div>
                    <p className="font-medium">{table.name}</p>
                    <p className="text-sm text-muted-foreground">
                      {table.row_count?.toLocaleString() || 0} registros
                    </p>
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onViewTable(table.name)}
                  data-testid={`view-table-${table.name}`}
                >
                  <Eye className="w-4 h-4 mr-1" />
                  Ver datos
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
